/**
 * NavList component
 *
 * @author chargoyao
 *
 * @prop handleActiveRedirectCreate {function} required click redirect to `edit segment`.
 * @notice need param the id of segment
 * @example
 * handleActiveRedirectCreate={() => this.handleActiveRedirectCreate(segmentId)}
 *
 * @prop popoutTip {function} required archive segment popout function
 *
 * @prop popout {boolean} required if display the confirmation for segment popout.
 *
 * @prop handleConfirmArchive {function} required when user click the button for `confirm archive`.
 * @notice need param, the id of segment
 * @example
 * handleConfirmArchive={() => this.handleConfirmArchive(segmentId)}
 *
 * @prop handleCancelArchive {function} required when user click `cancel` button. not to archive segment.
 *
 * @prop createCampaignPopover {function} create campaign popover function.
 * @notice need params, segment'id and segment's clientId
 * @example
 * createCampaignPopover={() => this.createCampaignPopover(segmentId, clientId)}
 *
 * @prop _handleDownloadPDF {function} download pdf
 * @notice need four params, segment_summary, segment_attributes, demoAttributes, geoAttributes
 * @exapmle
 * _handleDownloadPDF={() => this._handleDownloadPDF(segment_summary, segment_attributes, demoAttributes, geoAttributes)}
 *
 * @prop ifShowPdfDownload {boolean}
 */

import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Editer from 'material-ui/svg-icons/editor/mode-edit';
import InputIcon from 'material-ui/svg-icons/action/input'
import Archive from 'material-ui/svg-icons/content/archive';
import Create from 'material-ui/svg-icons/content/create';

class NavList extends Component {
  popoutTip () {
    this.props.popoutTip();
  }
  handleActiveRedirectCreate () {
    this.props.handleActiveRedirectCreate();
  }
  handleConfirmArchive () {
    this.props.handleConfirmArchive();
  }
  handleCancelArchive () {
    this.props.handleCancelArchive();
  }
  createCampaignPopover() {
    this.props.createCampaignPopover();
  }
  _handleDownloadPDF () {
    this.props._handleDownloadPDF();
  }
  render () {
    return (
      <ul style={{ margin: 0, padding: 0, display: this.props.visible === true ? "block" : "none" }}>
        <li style={{ listStyleType: 'none', padding: '1em' }} className="clearfix">
          <Editer style={{ float: 'left', width: '16px', height: '16px', marginRight: '0.6em' }} />
          <a style={{ color: '#0997F7', float: 'left' }} onClick={() => this.handleActiveRedirectCreate()}>Edit this segment</a>
        </li>
        <li style={{ listStyleType: 'none', padding: '1em', paddingTop: 0, display: this.props.ifShowPdfDownload ? 'block' : 'none' }} className="clearfix">
          <InputIcon
            style={{ float: 'left', width: '16px', height: '16px', marginRight: '0.6em' }}
          />
          <a style={{ color: '#0997F7', float: 'left', lineHeight: '1.3em' }}
             onClick={(e) => { e.preventDefault(); return this._handleDownloadPDF() }}>
            Download as a PDF
          </a>
        </li>
        <li style={{ listStyleType: 'none', position: 'relative', padding: '1em', paddingTop: 0 }}
            className="clearfix" onClick={() => this.popoutTip()}>
          <div className="clearfix">
            <Archive
              style={{ float: 'left', width: '16px', height: '16px', marginRight: '0.6em' }}
            />
            <a style={{ color: '#0997F7', float: 'left' }}>Archive this
              segment</a>
          </div>
        </li>
        {
          /^(system administrator|operations manager)/gi.test(this.props.roleName) && (
            <li style={{ listStyleType: 'none', position: 'relative', padding: '1em', paddingTop: 0 }}
                className="clearfix">
              <div className="clearfix">
                <Create
                  style={{ float: 'left', width: '16px', height: '16px', marginRight: '0.6em' }}
                />
                <a style={{ color: '#0997F7', float: 'left' }} onClick={() => this.createCampaignPopover()}>Create an Audience<br/>File</a>
              </div>
            </li>
          )
        }

        <div className={this.props.popout ? "archive-tips active" : "archive-tips"}>
          <p style={{ padding: 0, margin: 0 }}>Are you sure you want to archive this segment ?</p>
          <button className="confirm" onClick={() => this.handleConfirmArchive()}>
            Yes, archive this
          </button>
          <button className="concel" onClick={() => this.handleCancelArchive()}>Cancel</button>
        </div>
      </ul>
    )
  }
}

NavList.propTypes = {
  visible: PropTypes.bool.isRequired,
  popoutTip: PropTypes.func.isRequired,
  handleActiveRedirectCreate: PropTypes.func.isRequired,
  popout: PropTypes.bool.isRequired,
  handleConfirmArchive: PropTypes.func.isRequired,
  handleCancelArchive: PropTypes.func.isRequired,
  createCampaignPopover: PropTypes.func.isRequired,
  _handleDownloadPDF: PropTypes.func.isRequired
}

export default NavList;


// WEBPACK FOOTER //
// ./src/components/Segment/List/NavList.jsx